<template>
  <div id="app">
    <router-view/>
    <remote-script src="/pub"></remote-script>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  mounted() {
    let sysParams = [];
    this.$axios
      .get(`/api/fspj/sysParams`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          console.log(res.data.result);
          // sysParams = res.data.result;
          Cookies.set("sysParams", res.data.result);
        }
      })
      .catch(e => {
        console.log(e);
      });
      // console.log(sysParams);
  },
  metaInfo: {
    title: "BIS-1 Cloud Portal",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" }
    ]
  }
};
</script>


<style lang="scss">
body {
  margin: 0 auto;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .el-pager li:not(.active) {
    @media only screen and (max-width: 1020px) {
      display: none;
    }
  }
}
</style>
